import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';


const loadingPanel = (
    <div className="k-loading-mask">
        <div className="k-loading-image"></div>
        <div className="k-loading-color"></div>
    </div>
);

class Infoparam extends React.Component {
    state = {
        AwsApi: '',
        ShowLoader: true
}

    constructor(props: any) {
        super(props);
        this.fetchAwsApi = this.fetchAwsApi.bind(this);
        this.handlebuttonclick = this.handlebuttonclick.bind(this);
    }

    fetchAwsApi(){
        fetch('api/Registration/GetAwsParameters')
            .then(response => response.text())
            .then(data => {                
                this.setState({ AwsApi: data });
                this.setState({ ShowLoader: false });
            }).catch(error => {
                console.log(error);
            });
    }

    componentDidMount() {
        this.fetchAwsApi();
    }

    handlebuttonclick() {        
        this.setState({ ShowLoader: true });
        this.fetchAwsApi();
    }

    render() {
        return (
            <>
                <div>
                    {this.state.ShowLoader && loadingPanel}
                    <label id="lblAWSparam" className="parameterAWS">{ReactHtmlParser(this.state.AwsApi)}</label>                     
                </div>
                <div>
                    <button className="awsButton" onClick={this.handlebuttonclick}>Reload Parameters</button>
                </div>
           </>
        )
    }
}

export default Infoparam;

